import { Controller } from "@hotwired/stimulus"

/**
 * Click-to-insert for {{placeholder}} chips in the template editors.
 * Scope the controller on the editor form; authorable inputs carry
 * data-template-tokens-target="field" (the fallback insertion point —
 * used when no field has been focused yet — additionally carries
 * data-template-tokens-default). Chips are buttons with
 * data-action="template-tokens#insert" and
 * data-template-tokens-token-param="{{name}}".
 */
export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.lastField = null
    this.trackFocus = (event) => {
      if (this.fieldTargets.includes(event.target)) this.lastField = event.target
    }
    this.element.addEventListener("focusin", this.trackFocus)
  }

  disconnect() {
    this.element.removeEventListener("focusin", this.trackFocus)
  }

  insert(event) {
    const token = event.params.token
    const field = this.lastField || this.defaultField()
    if (!field) return

    const start = field.selectionStart ?? field.value.length
    const end = field.selectionEnd ?? field.value.length
    field.value = field.value.slice(0, start) + token + field.value.slice(end)

    const cursor = start + token.length
    field.focus()
    field.setSelectionRange(cursor, cursor)
    field.dispatchEvent(new Event("input", { bubbles: true }))
  }

  defaultField() {
    return (
      this.fieldTargets.find((field) => "templateTokensDefault" in field.dataset) ||
      this.fieldTargets[0]
    )
  }
}
